import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableCarrierPackageDimensionLock = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableCarrierPackageDimensionLock);
};
